import Button from "../components/Button";

export default function ErrorButton() {
  return (
      <div className="absolute top-0 left-0 flex flex-col w-full h-full">
    <Button
      onClick={() => {
        throw new Error("This is your first error!");
      }}
      text="Throw error"
    />
    </div>
  );
}
